(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kavity-hero-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kavity-hero')) {
    class KavityHero extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.kavity-hero__slide'));
        this.dots = Array.from(this.querySelectorAll('.kavity-hero__dot'));
        this.count = this.querySelector('.kavity-hero__count');
        this.pauseBtn = this.querySelector('.kavity-hero__pause');
        this.videos = Array.from(this.querySelectorAll('.kavity-hero__vid'));
        this.index = 0;
        this.total = this.slides.length;
        this.autoplay = this.dataset.autoplay === 'true' && this.total > 1;
        this.phoneQuery = window.matchMedia('(max-width: 749px)');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.current = null;
        this.raf = 0;
        if (!this.total) return;

        this.videos.forEach((v) => {
          v.muted = true;
          v.playsInline = true;
          v.removeAttribute('controls');
          v.removeAttribute('autoplay');
          v.autoplay = false;
          v.loop = this.total === 1;
          v.addEventListener('ended', () => {
            if (v === this.current && this.autoplay && !this.isPaused()) this.go(this.index + 1);
          });
        });

        // timer mode (image slides, or when the browser blocks autoplay)
        this.addEventListener('animationend', (e) => {
          if (e.animationName === 'kavity-hero-fill' && this.autoplay && !this.isPaused() && !this.classList.contains('is-vid')) {
            this.go(this.index + 1);
          }
        });

        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.go))));
        if (this.pauseBtn) this.pauseBtn.addEventListener('click', () => this.setPaused(!this.isPaused()));

        let x0 = null;
        this.addEventListener('pointerdown', (e) => {
          if (e.target.closest('a, button')) return;
          x0 = e.clientX;
        });
        this.addEventListener('pointerup', (e) => {
          if (x0 === null) return;
          const dx = e.clientX - x0;
          x0 = null;
          if (Math.abs(dx) > 50) this.go(dx < 0 ? this.index + 1 : this.index - 1);
        });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') this.go(this.index + 1);
          if (e.key === 'ArrowLeft') this.go(this.index - 1);
        });

        // desktop <-> phone swaps which video is visible
        const onBreakpoint = () => { this.syncTone(); this.playCurrent(); };
        if (this.phoneQuery.addEventListener) this.phoneQuery.addEventListener('change', onBreakpoint);
        else if (this.phoneQuery.addListener) this.phoneQuery.addListener(onBreakpoint);

        // Theme editor: jump to the slide being edited and hold it there
        this.addEventListener('shopify:block:select', (e) => {
          const i = this.slides.indexOf(e.target);
          if (i > -1) { this.go(i); this.setPaused(true); }
        });
        this.addEventListener('shopify:block:deselect', () => { if (this.autoplay) this.setPaused(false); });

        if (this.reduced) this.setPaused(true);
        this.go(0);
      }

      disconnectedCallback() { cancelAnimationFrame(this.raf); }

      isPaused() { return this.classList.contains('is-paused'); }

      videoOf(slide) {
        if (!slide) return null;
        const phone = this.phoneQuery.matches;
        if (phone && slide.classList.contains('has-vid-m')) return slide.querySelector('.kavity-hero__vid--m');
        return slide.querySelector('.kavity-hero__vid--d') || (phone ? slide.querySelector('.kavity-hero__vid--m') : null);
      }

      stopTrack() {
        cancelAnimationFrame(this.raf);
        this.raf = 0;
        this.classList.remove('is-vid');
      }

      track() {
        const v = this.current;
        const dot = this.dots[this.index];
        if (!v || !dot) return;
        const d = v.duration || 0;
        dot.style.setProperty('--p', d ? Math.min(1, v.currentTime / d) : 0);
        this.raf = requestAnimationFrame(() => this.track());
      }

      // Play the active slide's video; the progress bar follows it.
      // If playback is blocked (e.g. low-power mode), the CSS timer takes over.
      playCurrent() {
        this.stopTrack();
        const v = this.videoOf(this.slides[this.index]);
        this.current = v;
        this.videos.forEach((o) => { if (o !== v) o.pause(); });
        if (!v || this.reduced) return;
        try { v.currentTime = 0; } catch (e) {}
        if (this.isPaused()) return;
        const p = v.play();
        if (p && p.then) {
          p.then(() => {
            if (this.current === v && !this.isPaused()) { this.classList.add('is-vid'); this.track(); }
          }).catch(() => {});
        }
        const next = this.videoOf(this.slides[(this.index + 1) % this.total]);
        if (next && next !== v) next.preload = 'auto';
      }

      // Controls follow the active slide's text colour (phone can override it)
      syncTone() {
        const s = this.slides[this.index];
        if (!s) return;
        const tone = (this.phoneQuery.matches && s.dataset.toneM) || s.dataset.tone || 'dark';
        this.dataset.tone = tone;
      }

      go(n) {
        this.index = (n + this.total) % this.total;
        this.slides.forEach((s, i) => {
          const on = i === this.index;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
          if ('inert' in s) s.inert = !on;
        });
        this.dots.forEach((d, i) => {
          d.classList.remove('is-active');
          d.removeAttribute('aria-current');
          d.style.removeProperty('--p');
          if (i === this.index) {
            void d.offsetWidth;
            d.classList.add('is-active');
            d.setAttribute('aria-current', 'true');
          }
        });
        this.syncTone();
        if (this.count) {
          const pad = (x) => (x < 10 ? '0' : '') + x;
          this.count.textContent = pad(this.index + 1) + ' / ' + pad(this.total);
        }
        this.playCurrent();
      }

      setPaused(p) {
        this.classList.toggle('is-paused', p);
        if (this.pauseBtn) this.pauseBtn.setAttribute('aria-label', p ? 'Play slideshow' : 'Pause slideshow');
        const v = this.current;
        if (!v) return;
        if (p) {
          v.pause();
        } else if (!this.reduced) {
          const r = v.play();
          if (r && r.then) r.then(() => { this.classList.add('is-vid'); if (!this.raf) this.track(); }).catch(() => {});
        }
      }
    }
    customElements.define('kavity-hero', KavityHero);
  }

  } catch(e) { console.error(e); }
})();
})();
